import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import {SurgeVariant} from './types'

const SURGE_COLORS: Record<SurgeVariant, string> = {
  low: '#DE86FA',
  medium: '#C044F2',
  high: '#8822D0',
  ultra: '#4C0C79',
  max: '#32094F',
}

export const variant: Record<SurgeVariant, string> = {
  low: css`
    color: ${SURGE_COLORS.low};
  `,
  medium: css`
    color: ${SURGE_COLORS.medium};
  `,
  high: css`
    color: ${SURGE_COLORS.high};
  `,
  ultra: css`
    color: ${SURGE_COLORS.ultra};
  `,
  max: css`
    color: ${SURGE_COLORS.max};
  `,
}

export const icon = css`
  display: inline-flex;
  background-color: #f3ddfa;
  block-size: ${spacing(2)};
  border-radius: ${spacing(3)};
  box-sizing: border-box;
  font-size: ${spacing(1.5)};
  line-height: 1;
  font-weight: 600;
  padding: ${spacing(0.25, 0.5, 0.25, 0.25)};

  > svg {
    font-size: ${spacing(1.5)};
  }
`
